import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {BaseResponse} from "../../../../api/api";
import { IChatsCollectionsQuery } from '../../../chats/types/chatsTypes';
import {IRoomsCollection} from "../../types/roomsTypes";
import {snackbarAction} from "../../../errors/SnackbarSlice";

interface IResponse {
    collection: IRoomsCollection[]
}

export const fetchRoomsCollectionByOffset = createAsyncThunk<IRoomsCollection[],
    IChatsCollectionsQuery | void,
    ThunkConfig<string>>(
        'rooms/fetchRoomsCollectionByOffset',
        async (data, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            try {
                const response = await extra.api.get<BaseResponse<IResponse>>('room', {
                    params:data
                })

                if (!response.data.success) {
                    return rejectWithValue('error')
                }

                return response.data.response.collection
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                return rejectWithValue('error');
            }
        },
    );
